import {useContext} from "react";
import {useGetMyActiveCourses} from "@/app2/shared/data";
import {LocaleContext, resolveLocale} from "@/app2/shared/contexts";

/**
 * Active courses for My Progress with localized titles from the API.
 */
export const useActiveCourses = () => {
	const [{locale}] = useContext(LocaleContext);
	const resolvedLocale = resolveLocale(locale);
	const {data, isLoading, isError, error, refetch} = useGetMyActiveCourses({
		locale: resolvedLocale,
	});

	return {
		courses: data?.data ?? [],
		totalCount: data?.totalCount ?? 0,
		isLoading,
		isError,
		error,
		refetch
	};
};
